import { lazy } from "react";

const show = lazy(() => import("./Show").then(m => ({ default: m.FirmServiceProviderShow })));

export default { show };
